import { Campaign } from "../../@types/actor";
import { getSearchPivotLink } from "../../util";
import { SEARCH_KEYWORD_MAP } from "./consts";

export const getIOCSearchLink = (searchType: string, iocValue: string) => {
  const keyword = SEARCH_KEYWORD_MAP[searchType?.toLowerCase()];
  if (!keyword) return undefined;
  if (keyword === "hashes") {
    return getSearchPivotLink(`hashes:${iocValue}`);
  }
  return getSearchPivotLink(`${keyword}:"${iocValue}"`);
};

export const getCountryFromCountryCode = (countryCode?: string) => {
  const namer = new Intl.DisplayNames(["en"], { type: "region" });
  try {
    return namer.of(countryCode?.toUpperCase() ?? "");
  } catch (error) {
    return countryCode;
  }
};

export const refangIOCs = (ioc: string) => {
  if (!ioc) return ioc;

  return ioc
    .replace(/hxxps?:\/\//gi, match => match.replace(/x/gi, "t"))
    .replace(/\[:\]?/g, ":") // [:] → :
    .replace(/\[@\]/g, "@")
    .replace(/\[\.\]/g, ".");
};

export const getCampaignInfo = (data: Campaign, infoType: string) =>
  data?.iocs
    ?.filter(ioc => ioc.type === infoType)
    .map(ioc => ioc.value)
    .join(", ");
